// General
import { ready } from './lib/ready'

// Stimulus.js and controllers
import { Application } from 'stimulus';
import ExpandableController from './lib/expandable';
// import NavMainController from './lib/nav-main';
import HeaderController from './lib/header-controller';
import NavMainSubMenuController from './lib/nav-main-sub-menu-controller';

// Setup functions
import { InView } from './lib/in-view';
import { AnchorScrollTo } from './lib/anchor-scroll-to';
import { SetupSwiper } from './lib/setup-swiper';
import { FilterController } from './lib/filter-controller';

function scrollToHash() {
  if (location.hash) {
    const scrollTarget = document.querySelector(location.hash);
    if (scrollTarget) {
      const yVal = window.pageYOffset + scrollTarget.getBoundingClientRect().top - 124
      setTimeout(() => {
        window.scrollTo({
          top: yVal,
          left: 0,
          behavior: 'smooth'
        });
      }, 1)
    }
  }
}


const updatedScrolled = (lScrolled) => {
  if (lScrolled) {
    document.body.classList.add('-scrolled')
  } else {
    document.body.classList.remove('-scrolled')
  }
}

let scrolled = window.scrollY > 80
updatedScrolled(scrolled)

ready(function () {

  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  if (isIE11) document.body.classList.add("-is-ie-11");

  // Stimulus.js and controllers
  const application = Application.start();
  application.register('expandable', ExpandableController);
  // application.register('nav', NavMainController);
  application.register('header', HeaderController);
  application.register('nav-main-sub-menu', NavMainSubMenuController);
  application.register('filter', FilterController);


  window.addEventListener('scroll', () => {
    if (scrolled && window.scrollY <= 80) {
      scrolled = false;
      updatedScrolled(scrolled)
    } else if (!scrolled && window.scrollY > 80) {
      scrolled = true
      updatedScrolled(scrolled)
    }
  })

  scrollToHash();
  updatedScrolled(scrolled);

  // Setup functions
  InView();
  AnchorScrollTo(124);
  SetupSwiper();

});

window.onload = function () {
  scrollToHash();
};